import request from '@/utils/request'

export function message1List(data) {
    return request({
      url: '/admin/message1/list',
      method: 'post',
      data
    })
  }
  export function message1Delete(data) {
    return request({
      url: '/admin/message1/delete',
      method: 'post',
      data
    })
  }

  export function message1Save(data) {
    return request({
      url: '/admin/message1/save',
      method: 'post',
      data
    })
  }

  export function message1Update(data) {
    return request({
      url: '/admin/message1/update',
      method: 'post',
      data
    })
  }
  export function message1BatchSet(data) {
    return request({
      url: '/admin/message1/batchSet',
      method: 'post',
      data
    })
  }
  
// 个人
  export function message2List(data) {
    return request({
      url: '/admin/message2/list',
      method: 'post',
      data
    })
  }
  export function message2Delete(data) {
    return request({
      url: '/admin/message2/delete',
      method: 'post',
      data
    })
  }

  export function message2Save(data) {
    return request({
      url: '/admin/message2/save',
      method: 'post',
      data
    })
  }

  export function message2Update(data) {
    return request({
      url: '/admin/message2/update',
      method: 'post',
      data
    })
  }
  export function message2BatchSet(data) {
    return request({
      url: '/admin/message2/batchSet',
      method: 'post',
      data
    })
  }

